import React, { useState, useRef } from 'react';
import './TagInput.css';

const TagInput = ({ value, onChange, placeholder }) => {
    const [inputValue, setInputValue] = useState('');
    const inputRef = useRef(null);
    
    // Parse tags from comma-separated string
    const tags = value ? value.split(',').map(tag => tag.trim()).filter(tag => tag) : [];
    
    const addTag = (tagText) => {
        const trimmedTag = tagText.trim();
        if (trimmedTag && !tags.includes(trimmedTag)) {
            const newTags = [...tags, trimmedTag];
            onChange(newTags.join(', '));
        }
        setInputValue('');
    };
    
    const removeTag = (indexToRemove) => {
        const newTags = tags.filter((_, index) => index !== indexToRemove);
        onChange(newTags.join(', '));
    };
    
    const handleKeyDown = (e) => {
        if (e.key === 'Enter' || e.key === ',' || e.key === ' ') {
            e.preventDefault();
            addTag(inputValue);
        } else if (e.key === 'Backspace' && inputValue === '' && tags.length > 0) {
            removeTag(tags.length - 1);
        }
    };
    
    const handleInputBlur = () => {
        if (inputValue.trim()) {
            addTag(inputValue);
        }
    };
    
    return (
        <div className="tag-input-container" onClick={() => inputRef.current?.focus()}>
            <div className="tags-display">
                {tags.map((tag, index) => (
                    <span key={index} className="tag-box">
                        {tag}
                        <button
                            type="button"
                            className="tag-remove"
                            onClick={(e) => {
                                e.stopPropagation();
                                removeTag(index);
                            }}
                        >
                            ×
                        </button>
                    </span>
                ))}
                <input
                    ref={inputRef}
                    type="text"
                    value={inputValue}
                    onChange={(e) => setInputValue(e.target.value)}
                    onKeyDown={handleKeyDown}
                    onBlur={handleInputBlur}
                    placeholder={tags.length === 0 ? placeholder : ''}
                    className="tag-input"
                />
            </div>
        </div>
    );
};

export default TagInput;
